module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 35 35"
    }
  }, [_c('defs'), _c('g', {
    attrs: {
      "id": "Слой_2",
      "data-name": "Слой 2"
    }
  }, [_c('g', {
    attrs: {
      "id": "Слой_1-2",
      "data-name": "Слой 1"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M34.66,17.7c-.61-2-1.73-3.13-3.26-3.33-.22,0-.31-.12-.38-.44-.38-1.74-1.49-2.87-2.75-2.75-1.07.11-1.86.89-2.32,2.31a1,1,0,0,0,.23,1.13c.28.19.57,0,.74-.42.06-.15.11-.3.18-.44a1.43,1.43,0,0,1,1.5-1c.61.09,1,.57,1.31,1.36.11.31.1.48-.16.6a3.08,3.08,0,0,0-1.05.91,1.08,1.08,0,0,0-.08,1.11.46.46,0,0,0,.74.14c.09-.08.17-.19.25-.27A2.12,2.12,0,0,1,33,17a5.23,5.23,0,0,1,.5,4.77c-.12-.07-.15-.24-.23-.37a2.85,2.85,0,0,0-1.38-1.35c-.34-.15-.62,0-.73.44a.93.93,0,0,0,.38,1.06l.2.09c1.15.69,1.38,2.86.4,4.05-.12-.44-.22-.84-.35-1.22-.2-.59-.51-.77-.82-.52s-.36.67-.16,1.24A5.34,5.34,0,0,1,31.07,28c-.28,1.66-1.23,2.84-2.4,3a2.13,2.13,0,0,0-.25,0,.74.74,0,0,0-.54.83c0,.45.26.74.6.75,1.73.06,3.37-1.93,3.69-4.5a1.18,1.18,0,0,1,.41-.86,4.09,4.09,0,0,0,1.28-2.95,2.11,2.11,0,0,1,.25-.86A7.32,7.32,0,0,0,34.66,17.7Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M21.87,20.7a.47.47,0,0,0,.16,0c1.31-.81,2.61-1.61,3.91-2.44a.91.91,0,0,0,.24-1c-.14-.43-.38-.58-.7-.41s-.42.29-.64.42c-1,.64-2.07,1.27-3.11,1.9a.92.92,0,0,0-.39,1C21.39,20.46,21.58,20.66,21.87,20.7Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M25.88,27.89,22.1,25.53c-.29-.17-.54-.06-.7.33A.94.94,0,0,0,21.74,27l3.66,2.27a1.44,1.44,0,0,0,.26.12c.32,0,.51-.24.56-.64A.85.85,0,0,0,25.88,27.89Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M19.39,16.76a.37.37,0,0,0-.05-.11c-.33-.56-.63-1.15-.93-1.74a2.13,2.13,0,0,1-.23-1.19,23.71,23.71,0,0,0,0-2.92c-.19-3.25-1-6.09-2.89-8C12.59.08,9.58-.74,6.41.7,3.62,2,1.85,4.92.7,8.7a14.39,14.39,0,0,0,.17,9.37c.48,1.29,1,2.58,1.46,3.87A10.16,10.16,0,0,1,3,25.15a12.15,12.15,0,0,1,0,1.59,26.92,26.92,0,0,1-1.48,6.43,1,1,0,0,0,.19,1.19c.28.21.58.07.76-.42a25.84,25.84,0,0,0,1.67-8.17c0-.35.07-.53.18-.62A.53.53,0,0,1,4.57,25a3.54,3.54,0,0,0,2.89-2.29c.29-.6.29-.61.64-.06a.91.91,0,0,0,1.19.47c.45-.17.64-.7.72-1.32a5.07,5.07,0,0,0,0-1.23c-.05-.46-.29-.78-.57-.76s-.51.38-.52.87a3.56,3.56,0,0,1-.06.89A27,27,0,0,1,7.61,19c-.16-.38-.3-.78-.43-1.18-.25-.83-.09-1.28.51-1.54a2,2,0,0,1,.59-.1c.22,0,.34.05.37.43s.38.77.74.69.46-.49.4-1a2.26,2.26,0,0,0-.3-1c-.15-.23-.12-.34,0-.5A12.13,12.13,0,0,0,11,13.29a22.18,22.18,0,0,0,3.18-6c.14-.39.25-.55.57-.37a2.89,2.89,0,0,0,1.46.3c.22,0,.33.1.41.41a16.33,16.33,0,0,1,.5,5.63,5.09,5.09,0,0,0,.55,2.82c.4.74.8,1.47,1.18,2.23.26.52.25.58-.18.68s-.87.55-1,1.33a2.32,2.32,0,0,0,.07.95.31.31,0,0,1-.12.39,1.29,1.29,0,0,0-.25,1.89c.08.13.13.22,0,.38a2.07,2.07,0,0,0-.22,1.19,2.46,2.46,0,0,0,0,.26c.09.95-.07,1.29-.7,1.6a2.05,2.05,0,0,1-.41.16,18.31,18.31,0,0,0-2.09.7A2.07,2.07,0,0,0,13,29.46c-.28,1.45-.46,2.93-.63,4.41-.07.63.08,1,.41,1.11s.59-.21.67-.85c.14-1.08.32-2.14.41-3.22s.5-1.68,1.28-1.83a5.6,5.6,0,0,0,2-.7,2.92,2.92,0,0,0,1.18-3c0-.08,0-.14,0-.21a1.16,1.16,0,0,1,.12-.55A1.9,1.9,0,0,0,18.58,23a.3.3,0,0,1,.05-.31,1.77,1.77,0,0,0,.2-1.56c-.11-.43,0-.57.27-.66a1.51,1.51,0,0,0,.29-.13A1.91,1.91,0,0,0,20,18,8.77,8.77,0,0,0,19.39,16.76Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M25.55,22.28q-2.31,0-4.62,0c-.45,0-.7.31-.7.82s.26.77.69.78h4.62c.45,0,.71-.31.7-.82S26,22.28,25.55,22.28Z"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23f75c6a","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppSvgIconNew/templates/icons/breath.vue
// module id = 1d9dfc254e6131e7d7c0
// module chunks = 89